import React from "react";
import ReactDOM from "react-dom";
import ReactGA from "react-ga";
import { BrowserRouter, Route, Switch } from "react-router-dom";
// import { deploymentEnvironment } from "../../variables/Variables";
import App from "./containers/App/App.jsx";

import "./assets/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/sass/light-bootstrap-dashboard.css";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";

// ES6 module syntax

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path="/" name="Home" component={App} />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
